module.exports = __webpack_public_path__ + "static/Kirsche-eb13da1997e080905c321b9a046a5260.png";